export const load = () => ({
	title: 'How to Prepare for the Polar Vortex',
	showTitle: true,
});
